export default {
  'Please select an output format': '请选择一个输出格式：',
}